import type { FaireProductEntity } from "../../entity_types/product";

export const p_c4z26gu3ds: FaireProductEntity = {
  token: "p_c4z26gu3ds",
  type: "product",
  name: "Colorblock Leopard Print Long Knit Pocket Cardigan MMY319",
  brandToken: "b_9qqlp5kqt7",
  brandName: "UNISHE",
  imageUrl:
    "https://cdn.faire.com/fastly/1a1047c954a13ddda3e3301e2d5c08e21930a7acf4b45531bf01361380346c4b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63aadb4e63da660684b98cd953b0596c6454316eeda2c7a906e4215d50c5d291.jpeg",
    "https://cdn.faire.com/fastly/d93c90cebd6fd895eb393868bbe61ec92de5c4bec54b562a0dccba62a5f74107.png",
    "https://cdn.faire.com/fastly/b37ce0c835b831b1e26fda1f9c8b5e7c57dbd0feaf7d7bb6b221c8f3590a7977.png",
    "https://cdn.faire.com/fastly/361334b15cd2b024d162cc6507a791be344e5dda3b1325020bed4de97f4e1f3e.png",
    "https://cdn.faire.com/fastly/7b4ac19ce3e3c783ac476e0bf41a83e4a743eeb2061bd72081e6ba8f92ff0622.png",
    "https://cdn.faire.com/fastly/4ae8dea8297cef72235a33ae75fa8dd845274bb57548315e6f730ae053bc7987.png",
  ],
  priceDollars: 20.99,
  description:
    "Colorblock Leopard Print Long Knit Pocket Cardigan MMY319\n\nTrendy Colorblock Design: Features bold colorblock patterns combined with leopard print for a modern, eye-catching look.\n\nSoft Knit Fabric: Made from cozy knit material, offering warmth, softness, and comfort for everyday wear.\n\nLongline Silhouette: The extended length provides extra coverage, creating a flattering and elegant layered style.\n\nPractical Side Pockets: Designed with roomy pockets for added convenience, keeping small essentials close at hand.\n\nVersatile Styling Piece: Perfect for pairing with jeans, dresses, or leggings, making it suitable for casual outings, work, or lounging.\n\nSize Chart (cm)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t104.00 \t47.0 \t92.0 \nM\t108.00 \t48.0 \t93.0 \nL\t114.00 \t49.0 \t95.0 \nXL\t120.00 \t50.0 \t97.0 \n\nSize Chart (inch)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t40.9 \t18.5 \t36.2 \nM\t42.5 \t18.9 \t36.6 \nL\t44.9 \t19.3 \t37.4 \nXL\t47.2 \t19.7 \t38.2",
  tags: [],
  msrpDollars: 41.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:26.725Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
